export const STATUS = Object.freeze({
  open: 'פתוחה',
  closed: 'סגורה',
  sentToClient: 'נשלחה ללקוח',
  paid: 'בוצע תשלום',
  pdfGenerated: 'הופק מסמך הצעה',
  paidAndGeneratedPdf: 'הופק מסמך ובוצע תשלום',
});

export const CLIENT_STATUS = Object.freeze({
  approved: 'אושר',
  pendingApproval: 'לא אושר',
});

export const STATUS_COLOR = Object.freeze({
  open: 'grape',
  closed: 'lime',
  sentToClient: 'blue',
});

export const COMPANIES_ORDER = Object.freeze([
  { name: 'הפניקס', order: 1 },
  { name: 'הראל', order: 2 },
  { name: 'כלל', order: 3 },
  { name: 'איילון', order: 4 },
  { name: 'קרדיט 360', order: 5 },
]);

export const PROBLEM_TYPES = Object.freeze({
  bankingConduct: 'bankingConduct',
  loanAmount: 'loanAmount',
  any: 'any',
});

export const SSE_TYPES = Object.freeze({
  process: 'process',
  message: 'message',
});

export const loanGoalOptions = [
  { value: 'mortgage', label: 'דיור', more: 'mortgage' },
  { value: 'general', label: 'כל מטרה', more: 'general' },
  { value: 'cycleMortage', label: 'מחזור דיור', more: 'mortgage' },
  { value: 'cycleGeneral', label: 'מחזור כל מטרה', more: 'general' },
];

export const chartColors = [
  '#0066cc',
  '#00cc66',
  '#cc6600',
  '#cc0066',
  '#66cc00',
  '#0099cc',
  '#cc0099',
  '#009999',
];
